import { getEvaluationsAndRoutineFrequenciesForOrderOptions } from '@generated';
import { useOrderItems } from '~/features/orders/queries';

export function useEvaluationsAndRoutineFrequencies(orderId: string) {
	return useOrderItems(orderId, getEvaluationsAndRoutineFrequenciesForOrderOptions, (fullOrder, result) => {
		fullOrder.evaluations = result.evaluations;
		fullOrder.routine = result.routine;
		fullOrder.routinePrnFrequencies = result.routinePrnFrequencies;
		fullOrder.suggestedFrequenciesApplied = result.suggestedFrequenciesApplied;
		fullOrder.discontinuedFrequencies = result.discontinuedFrequencies;
		fullOrder.discontinuedRoutinePrnFrequencies = result.discontinuedRoutinePrnFrequencies;
	});
}
